type LoadedContent = {
  loading: boolean;
  content: string | undefined;
  contentType: string | undefined;
  truncated: boolean;
};

// Why a run's input/output can't be pinned as a step test, or null if it
// can. Both sides must be loaded, inline (text/JSON/HTTP, so `content` is
// defined), and small enough to inline (not truncated).
export function pinContentIssue(
  output: LoadedContent,
  input: LoadedContent
): string | null {
  // `content` is undefined both before a response lands and after one that
  // wasn’t inline text, so keying off it alone flashes the not-inline message
  // while a run is still fetching. `contentType` is only set once a response
  // lands, so it separates “still loading” from “loaded, not inline”.
  const settled = (c: LoadedContent) =>
    !c.loading && c.contentType !== undefined;
  if (!settled(output) || !settled(input)) return "Loading this run’s output…";
  if (output.truncated || input.truncated)
    return "This run’s input or output is too large to add as a step test.";
  if (output.content === undefined || input.content === undefined)
    return "Step tests are only available for runs with text, JSON, or HTTP input and output.";
  return null;
}
